import { getObject, postObject, jsonToUrlEncoded } from '../ChoiceApi';
import { IQuickPayDemographicsSummaryResult, IQuickPayIDResponse, IQuickPayPatientResult, IQuickPayReceiptResponse,
    IQuickPayReceiptRecord, IQuickPayReceiptCreateResponse, IQuickPayReceiptItem, IQuickPayTakePaymentInputs,
    IQuickPayReceiptBatchIdCreateResponse, IQuickPayReceiptCharge, IQuickPayEmrFrameInputs, IQuickPayRxResponse,
    IQuickPayTabNotificationResult } from '../Models/QuickPayModel';
import { IPatientPrintFaxQueueInitialize} from '../Models/PatientModel';

export async function printFaxQueueInitialize(patientId: number): Promise<IPatientPrintFaxQueueInitialize|undefined> {
    return await getObject(`api/Patient/GetPrintFaxQueueInitialize/${patientId}`);
}

export async function DemographicsSummary(patientId: number): Promise<IQuickPayDemographicsSummaryResult|undefined> {
    return await getObject(`api/Patient/QuickPay/DemographicsSummary/${patientId}`);
}

export async function IDs(patientId: number): Promise<IQuickPayIDResponse|undefined> {
    return await getObject(`api/Patient/QuickPay/IDs/${patientId}`);
}

function getQuickPayExtension(appointmentId?: number, receiptId?: number, receiptBatchId?: number): string {
    let extension = "";
    if (receiptId) extension = `?receiptId=${receiptId}`;
    else if (appointmentId) extension = `?appointmentId=${appointmentId}`;
    else if (receiptBatchId) extension = `?receiptBatchId=${receiptBatchId}`;
    return extension;
}

export async function Patient(patientId: number, appointmentId?: number, receiptId?: number): Promise<IQuickPayPatientResult|undefined> {
    return await getObject(`api/Patient/QuickPay/Patient/${patientId}${getQuickPayExtension(appointmentId, receiptId)}`);
}

export async function Receipt(patientId: number, appointmentId?: number, receiptId?: number): Promise<IQuickPayReceiptResponse|undefined> {
    return await getObject(`api/Patient/QuickPay/Receipt/${patientId}${getQuickPayExtension(appointmentId, receiptId)}`);
}

export async function ReceiptList(patientId: number, appointmentId?: number, receiptId?: number, receiptBatchId?: number): Promise<IQuickPayReceiptItem[]|undefined> {
    return await getObject(`api/Patient/QuickPay/ReceiptList/${patientId}${getQuickPayExtension(appointmentId, receiptId, receiptBatchId)}`);
}

export async function ReceiptCharge(patientId: number, appointmentId?: number, receiptId?: number, receiptBatchId?: number): Promise<IQuickPayReceiptCharge|undefined> {
    return await getObject(`api/Patient/QuickPay/ReceiptCharge/${patientId}${getQuickPayExtension(appointmentId, receiptId, receiptBatchId)}`);
}

export async function ReceiptCreate(payload: IQuickPayReceiptRecord): Promise<IQuickPayReceiptCreateResponse|undefined> {
    return await postObject("api/Patient/QuickPay/ReceiptCreate", payload);
}

export async function ReceiptBatchIdCreate(patientId: number, appointmentId?: number, receiptId?: number): Promise<IQuickPayReceiptBatchIdCreateResponse|undefined> {
    return await getObject(`api/Patient/QuickPay/ReceiptBatchIdCreate/${patientId}${getQuickPayExtension(appointmentId, receiptId)}`);
}

export async function TakePayment(payload: Record<string,object>): Promise<void> {
    const window_parms = jsonToUrlEncoded(payload);
    const window_features = "popup=yes,resizable=yes,width=940,height=500,top=10,left=10";
    const window_url = `/officemd/App/billing/PaySimpleCreditCard?${window_parms}`
    window.open(window_url,"credit_popup",window_features); 
}

export async function TabNotification(patientId: number, appointmentId?: number): Promise<IQuickPayTabNotificationResult|undefined> {
    return await getObject(`api/Patient/QuickPay/TabNotification/${patientId}${appointmentId ? "/" + appointmentId : ""}`);
}

export async function RxHistoryList(patientId: number, appointmentId?: number): Promise<IQuickPayRxResponse|undefined> {
    return await getObject(`api/Patient/QuickPay/RxHistoryList/${patientId}${appointmentId ? "/" + appointmentId : ""}`);
}

export function BuildEMRInputs(inputs: IQuickPayEmrFrameInputs) {
    return  [inputs.tabName ?? "", 
        inputs.securityUsersId ?? "", 
        inputs.patientId, 
        inputs.patientEid ?? "", 
        inputs.providerEid ?? "", 
        inputs.appointmentId ?? "", 
        inputs.walkInPatient == "Y" ? "Y" : "N", 
        inputs.encounterDate, 
        inputs.encounterTime ?? "", 
        inputs.searchCriteria ?? "",
        inputs.patientPullType ?? "",
        inputs.patientPullData ?? "",
        inputs.claimId ?? ""
    ].join("|");
}
